import api from "../api/api";

export interface CountryResponse {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  currency: string;
}
export interface CurrencyResponse {
  code: string;
  name: string;
  symbol: string;
  country: string;
}
export interface CurrencyRateResponse {
  id: number;
  conversion_date: string;
  currency: string;
  rate: string;
}

export async function getAllCountries(
  access_token: string,
  sectorId?: number,
  subSectorId?: number
): Promise<CountryResponse[]> {
  try {
    const params: Record<string, string | number> = {};
    if (sectorId) params.sector_id = sectorId;
    if (subSectorId) params.sub_sector_id = subSectorId;
    const response = await api.get<CountryResponse[]>(`/api/v1/lookup/countries/`, {
      headers: { Authorization: `Bearer ${access_token}` },
      params,
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching countries:", error.response?.data || error.message);
    throw error;
  }
}

export async function getAllCurrencies(
  access_token: string
): Promise<CurrencyResponse[]> {
  try {
    const response = await api.get<CurrencyResponse[]>(`/api/v1/lookup/currencies/`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching currencies:", error.response?.data || error.message);
    throw error;
  }
}

export async function getAllCurrenciesByCountry(
  access_token: string,
  countryIso2: string
): Promise<CurrencyResponse[]> {
  try {
    const response = await api.get<CurrencyResponse[]>(`/api/v1/lookup/currencies/`, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: { iso2: countryIso2 }
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching currencies by country:", error.response?.data || error.message);
    throw error;
  }
}

export async function getAllCurrencyConvRate(
  access_token: string,
  countryIso2: string,
  currency: string
): Promise<CurrencyRateResponse[]> {
  try {
    const response = await api.get<CurrencyRateResponse[]>(`/api/v1/lookup/currency-conversion-rates/`, {
      headers: { Authorization: `Bearer ${access_token}` },
      params: {   
        country: countryIso2,
        currency: currency
      }
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching currency conversion rates:", error.response?.data || error.message);
    throw error;
  }
}
